import { useState } from 'react'
import { Dispatch, FC, SetStateAction } from 'react'
import ReactCodeInput from '@acusti/react-code-input'
import Button from 'react-bootstrap/Button'

import { isIOS } from 'share/utils/isiOs'
import {
  CodeVerificationContainer,
  CodeVerificationSend,
  CodeVerificationSubmit,
  CodeVerifyWithinInfo,
  iOSCodeInputStyle
} from 'components/atoms/InputFields/CodeVerification'

const style = !isIOS ? {} : iOSCodeInputStyle

interface NewAccountVerifyYourPhoneNumberFormProps {
  completePhoneVerificationHelper(input: string): void
  enteredCode: string
  enteredCodeComplete: boolean
  resendVerificationCode(): void
  setEnteredCode: Dispatch<SetStateAction<string>>
  setEnteredCodeComplete: Dispatch<SetStateAction<boolean>>
}

const NewAccountVerifyYourPhoneNumberForm: FC<NewAccountVerifyYourPhoneNumberFormProps> =
  ({
    completePhoneVerificationHelper,
    enteredCode,
    enteredCodeComplete,
    resendVerificationCode,
    setEnteredCode,
    setEnteredCodeComplete
  }) => {
    const [submitting, setSubmitting] = useState(false)
    const onSubmit = async (
      e: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
      e.preventDefault()
      setSubmitting(true)

      await completePhoneVerificationHelper(enteredCode)
      setSubmitting(false)
    }

    const handleCodeChange = (val: string) => {
      if (val?.length === 6) {
        setEnteredCode(val)
        setEnteredCodeComplete(true)
        return
      }

      setEnteredCodeComplete(false)
    }

    return (
      <CodeVerificationContainer data-testid='create-account-account-verify-phone-container'>
        <p>Please enter the verification code below.</p>
        <ReactCodeInput
          autoFocus
          className='ui-code-verification-inputs'
          fields={6}
          inputMode='numeric'
          inputStyle={style}
          name='verifyPhoneNumber'
          type='number'
          value={enteredCode}
          onChange={handleCodeChange}
        />
        <CodeVerifyWithinInfo>
          Please verify within 5 minutes.
        </CodeVerifyWithinInfo>

        <CodeVerificationSend data-testid='create-account-account-verify-phone-send'>
          Didn't get a code?{' '}
          <span
            role='button'
            onClick={resendVerificationCode}
            data-testid='create-account-account-verify-phone-resend-code-button'
          >
            Send it again
          </span>
        </CodeVerificationSend>
        <CodeVerificationSubmit>
          <Button
            className='ui-button-with-spinner'
            disabled={!enteredCodeComplete || submitting}
            type='submit'
            onClick={onSubmit}
            data-testid='create-account-account-verify-phone-next-button'
          >
            Next
          </Button>
        </CodeVerificationSubmit>
      </CodeVerificationContainer>
    )
  }

export default NewAccountVerifyYourPhoneNumberForm
